
const _colors = [
  "#00aba9", "#00fff5", "#1ba1e2", "#3cdbd3", "#77b6ea", "#7dce82", 
  "#95adb6", "#a200ff", "#b9e5ff", "#c1ffbc", "#cbb3bf", "#dbc7be", 
  "#dfb9ff", "#e8e288", "#f09609", "#f7b9ff", "#ff0097"
]

/*

this simple class creates a dictionary of city-color pairs

it assigns these in order

*/

class CityColorer {
  constructor() {
    this._cityColor = {}
    this._colorIdx = 0
  }

  get(k) {
    if (!this._cityColor[k]) {
      this._cityColor[k] = _colors[this._colorIdx]
      this._colorIdx = ((this._colorIdx + 1) % _colors.length)
    }
    return this._cityColor[k]
  }
}

export default CityColorer